import { IColumns, getRandomId, StoreFuncs } from "../../ExcelStore";
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { getBrowserValue, dotPngImg, getHreflink, linkedColor } from './FieldCellType';
import { WeaBrowser } from 'ecCom';
import { isArray, get } from 'lodash';
import { removeHTMLTag } from "../../../../util";
const searchPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADjklEQVRYR82XS4gcVRSG/3MrI2MLNoZBfGCQCAlm4duFYwgawYUKzjjgwsfgQhwlZtx01+kBY4oY6Lq3mxloHwvjzmCwkRghQUWCj/gCgxIJ+EAZERc+ogjCVJx03V8KZkJPT4+ddHcSa1d1T53/u4dz7jlXcI4fOcf6aAtQrVaH0jS9H8DFfQL8SlX3tvO1DMBae4eI7AZwSZ/EF90cTdN0fGpq6stmv0sAKpXKZpIHSTYAvAjgkDHmWC8g3vshEdlE8gkRmUvT9LZmiJMAlUrlAu/9dwthv0VVD/ci3PqvtfYmEfkMwI9zc3ProijymU0zwCjJvSSfV9Wt/RRf9GWtfU5EnvTe31Uqld5aAuCcexbA0yIyUiwW3zxDACMi8gaAnWEYbmsFqAHYKiLDxWLx0zMBEMfxsDHmY5I1VX2qK4BqtbrBe28BXAtgiORPAD4BYFX12/8C7xnAWlsUkTKA4yQ/EpGjANYBuBPAed77iVKptGsliJ4AKpXKdpIRgKnBwcGZycnJfxaFZmZmLp2fn6+LyEaS46r6SjuIrgGcc9cB+ILkTlV9pp3zKIpMLpfbTXJzkiRXRlF0vNWuawBr7WsicmM+n796YmLixEohLpfLa4Mg+AHAA2EY7uknwC8A3lbVRzpVh3Pua5KHVPWxfgL8JSIvh2FYOAWAIySPqOp4PwG+AfC9qt7TCcBamyXnS+1O065zwDmX1f3jxpirCoXCis3JOfcogF0kR1V1X98iEMfxmoWa39cutJmQc+4GAO8B+COfz69vl6xdR2BBYIxkHcB+AFtU9efs+/T09OpGo3EfyaqIJAA2hmGYVcKypyeAzFscx5tEZI+IXJYlGoCLROSKrKuSfLfRaDw8MDBwgOSxJElGWs+CngEyiFqtdmGSJPcaY9Z677N2foLk4VKp9M5CpLJT8CGSB1qTti8AnaogiqJVuVzuVZKXq+qtzfZnBaDrbmit3SEi20iOrTTBdtp9p3Xn3BiA1wHsCMNw+5J5II7ju40x+8/GSNa8yZMzYb1eD2ZnZ7OhdE0QBMOFQuHzTjs6nfVqtXpzmqbZ4PI7gPWq+veSCGQv5XL5emPMBwDOF5EXSH5ojPnzdIRabb33qxfG8i0iskpEbi8Wi+8v2i27mGQQQRBkF5MNvQi3/kvyVwAPqurB5rW2VzOS4pwbBXBNnyB+C4Kg3q6P/D8vp33a9Sm5+Rc3K0w/m9eDxAAAAABJRU5ErkJggg=='
const searchPngImg = document.createElement("img");
searchPngImg.src = searchPng;
const div = document.createElement('div');
document.body.appendChild(div);
export default (column: IColumns, editable: boolean) => {
    const { type, dbtype, isSingle,dataParams,destDataParams,tabs,conditionDataParams,hasAdvanceSerach,scrollx} = column;
    class Type extends GC.Spread.Sheets.CellTypes.Base {
        browserInstance;
        dataParams: any;
        destDataParams: any;
        tabs:any={};
        hasAdvanceSerach:any;
        scrollx:any;
        conditionDataParams:any;
        _itemsTextWidth: any = {};
        _sumItemTextWidth: any = {};
        _itemsTextRowIndex: any = {};
        _itemsRect: any = {};
        _items: any = {};
        startY: any = {};
        allowOverflow = false;
        editor: HTMLDivElement;
        secretLevel?: any;
        timer;
        constructor() {
            super();
            this.allowOverflow = false;
            if (type === '161' || type === '162') {
                this.dataParams = {
                    type: dbtype
                }
                this.hasAdvanceSerach = true;
                this.destDataParams = destDataParams;
                this.conditionDataParams = conditionDataParams;
            }else if(type === '256' || type === '257'){
                this.dataParams = dataParams;
                this.destDataParams = destDataParams;
                this.conditionDataParams = conditionDataParams;
                this.tabs = tabs||{};
                this.hasAdvanceSerach = hasAdvanceSerach;
                this.scrollx = scrollx;
            }else{
                this.hasAdvanceSerach = true;
                this.destDataParams = this.dataParams;
                this.conditionDataParams = this.dataParams; 
            }
        }
        processMouseMove(hitInfo: GC.Spread.Sheets.IHitTestCellTypeHitInfo) {
            const { sheet, isReservedLocation, reservedLocation = {} } = hitInfo as any;
            var div = sheet.getParent().getHost();
            var canvasId = div.id + "vp_vp";

            var canvas = $("#" + canvasId)[0];
            if (sheet && isReservedLocation) {
                canvas.style.cursor = 'pointer';
                canvas.title = reservedLocation.names || reservedLocation.name
                return true;
            } else {
                canvas.title = "";
                canvas.style.cursor = 'default';
            }
            return false;
        };
        processMouseLeave(hitInfo: GC.Spread.Sheets.IHitTestCellTypeHitInfo): boolean {
            const { sheet } = hitInfo as any;
            var div = sheet.getParent().getHost();
            var canvasId = div.id + "vp_vp";
            var canvas = $("#" + canvasId)[0];
            canvas.title = "";
            canvas.style.cursor = 'default';
            return true;
        }
        processMouseUp(hitInfo: GC.Spread.Sheets.IHitTestCellTypeHitInfo): boolean {
            const { x, y, cellRect, sheet, row, col, sheetArea, reservedLocation, isReservedLocation } = hitInfo as any;
            if (editable && x && cellRect) {
                if (x >= cellRect.x + cellRect.width - 20) {
                    this.showBrowserModal(sheet.getCell(row, col, sheetArea), cellRect);
                }
                return true;
            }
            if (sheet && isReservedLocation && reservedLocation && reservedLocation.linkUrl) {
                const hreflink = getHreflink(sheet.getValue(row, col, sheetArea));
                if (hreflink) {
                    (window as any).cubeOpenHreflinkFromExcel(hreflink);
                } else {
                    if (reservedLocation.linkUrl.toLowerCase().startsWith('javascript:openhrm')) {

                        div.style.position = 'absolute';
                        div.style.left = x + 'px';
                        div.style.top = y + 'px';
                        div.style.visibility = 'hidden';
                        setTimeout(() => {
                            (window as any).pointerXY({
                                ...window.event,
                                target: div
                            })
                            eval(reservedLocation.linkUrl.replace('javascript:', ''))
                        }, 10);

                    } else {
                        window.open(reservedLocation.linkUrl)
                    }
                }
                return true;
            }

            return super.processMouseUp(hitInfo);
        }

        paint(ctx: CanvasRenderingContext2D, value: any, x: number, y: number, w: number, h: number, style: GC.Spread.Sheets.Style, context?: any) {
            ctx.clearRect(x, y, w, h);
            const { row, col, sheet } = context;
            ctx.font = style.font;
            delete style.vAlign;
            const browserVals =  getBrowserValue(value);
            const datas: any = browserVals&&browserVals.length ? browserVals : [{name: ''}];
            this._sumItemTextWidth[row] = [];
            this._itemsRect[row] = [];
            this._itemsTextRowIndex[row] = [];
            const splitWidth = parseInt(ctx.measureText(',').width.toString());
            let rowIndex = 0;
            this._sumItemTextWidth[row][rowIndex] = 0;
            this._items[row] = [];
            this._items[row][rowIndex] = [];
            this._itemsTextWidth[row] = [];
            this._itemsTextWidth[row][rowIndex] = [];
            const _width = editable ? w - 20 : w;
            let leftHeight = h;
            if (!editable) {
                style.foreColor = linkedColor;
                style.textDecoration = GC.Spread.Sheets.TextDecorationType.underline;
            }
            const dataArray = datas.map((data, index) => {
                let {name} = data;
                if(name){  
                    name=removeHTMLTag(name);
                }
                const textWidth = parseInt(ctx.measureText(name).width.toString());
                if (this._sumItemTextWidth[row][rowIndex] + textWidth > _width && this._sumItemTextWidth[row][rowIndex] !== 0) {
                    rowIndex++;
                    this._items[row][rowIndex] = [];
                    this._sumItemTextWidth[row][rowIndex] = 0;
                    this._itemsTextWidth[row][rowIndex] = [];
                    leftHeight -= 20;
                    leftHeight = leftHeight < 0 ? 0 : leftHeight;
                }

                const rt = {
                    ...data,
                    left: x + this._sumItemTextWidth[row][rowIndex],
                    splitLeft: 0,
                    top: y + 20 * rowIndex,
                    height: leftHeight,
                    notLast: index < datas.length - 1
                };
                this._itemsTextWidth[row][rowIndex].push(textWidth);
                this._items[row][rowIndex].push(data);
                this._sumItemTextWidth[row][rowIndex] += textWidth;
                rt.splitLeft = x + this._sumItemTextWidth[row][rowIndex];
                if (rt.notLast) {
                    this._sumItemTextWidth[row][rowIndex] += splitWidth;
                }
                return rt;
            });
            this.startY[row] = Math.max(0, (h - rowIndex * 20 - 20) / 2);
            dataArray.forEach(data => {
                const { left, top, height, notLast, splitLeft } = data;
                let {name} = data;
                if(name){
                    name=removeHTMLTag(name);
                }
                const realTop = this.startY[row] + top;             
                super.paint(ctx,name, left, realTop, _width, height, style, context);
                if (notLast) {
                    super.paint(ctx, ',', splitLeft, realTop, _width, height, style, context);
                }
            })
            if (editable) {
                const width = Math.min(16, h);
                ctx.drawImage(searchPngImg, x + w - width, y + (h - width) / 2, width, width);
                if (get(sheet.modifyedValues, `${StoreFuncs.getRandomId(row)}.${col}`)) {
                    ctx.drawImage(dotPngImg, x, y, 8, 8);
                }
            }
        }
        getHitInfo(x: number, y: number, cellStyle: GC.Spread.Sheets.Style, cellRect: GC.Spread.Sheets.Rect, context?: any): GC.Spread.Sheets.IHitTestCellTypeHitInfo {
            const { row, col, sheetArea, sheet } = context;
            const info = {
                x,
                y,
                row,
                col,
                cellRect,
                sheetArea,
                sheet,
            } as any;
            const rowIndex = parseInt('' + ((y - cellRect.y - this.startY[row]) / 20));
            if (rowIndex < this._sumItemTextWidth[row].length && x < cellRect.x + this._sumItemTextWidth[row][rowIndex]) {
                let startX = cellRect.x
                const datas = this._items[row][rowIndex] || [];
                for (let i = 0; i < datas.length; i++) {
                    if (x < startX + this._itemsTextWidth[row][rowIndex][i]) {
                        info.isReservedLocation = true;
                        info.reservedLocation = datas[i];
                        break;
                    }
                    startX += (this._itemsTextWidth[row][rowIndex][i]);
                }
            }
            return info;
        }
        getAutoFitWidth(value: any, text: string, cellStyle: GC.Spread.Sheets.Style, zoomFactor: number, context?: any): number {
            const datas = getBrowserValue(value);
            return super.getAutoFitWidth(value, datas.map(d => d.name).join(','), cellStyle, zoomFactor, context) + (editable ? 20 : 0);
        }
        showBrowserModal(context: GC.Spread.Sheets.CellRange, cellRect: GC.Spread.Sheets.Rect) {
          
            const { sheet, row, col } = context;
            if (!this.editor) {
                this.editor = document.createElement('div');
                const host = sheet.getParent().getHost();
                host.appendChild(this.editor);
                this.editor.style.visibility = 'hidden';
                $(this.editor).css({
                    position: 'absolute',
                    left: cellRect.x,
                    top: cellRect.y,
                    width: cellRect.width,
                    height: cellRect.height,
                });
            }

            const value = context.value();

            const changeValue = (newValue, valueSpan, valueObj) => {
                sheet.suspendPaint();
                const value = context.value();
                let newValueSpan = {};
                let oldValueSpan = {};
                let oldValue = '';
                try {
                    const { datas: oldDatas } = JSON.parse(value);
                    if (isArray(oldDatas)) {
                        oldValue = oldDatas.map(d => d.id).join(',');
                    }
                    oldValueSpan = { value: oldValue, datas: oldDatas };
                    newValueSpan = { value: newValue, datas: valueObj };
                } catch (e) {
                    newValueSpan = { datas: valueObj, value: newValue };
                    oldValueSpan = { value: oldValue, datas: [] };
                }
                const dataSource = sheet.getDataSource();
                const datas = dataSource.getValue("datas");
                const data = datas[row];
                data[column.column] = newValue;
                data[`${column.column}span`] = JSON.stringify(newValueSpan);
                (sheet as any).setChangedValue(getRandomId(data), column, { sheet, row, col, newValue: newValueSpan, oldValue: oldValueSpan,time:data.time });
                sheet.resumePaint();
            }
         
            if(sheet.getDataSource().xf.datas[row].seclevel!=undefined &&sheet.getDataSource().xf.datas[row].seclevel!=""){
                this.secretLevel = sheet.getDataSource().xf.datas[row].seclevel
            }else{
                this.secretLevel=4;
            }
            const replaceDatas = getBrowserValue(value);
            ReactDOM.unmountComponentAtNode(this.editor);
           
            let obj={
                "secretLevel":this.secretLevel
            }
            this.dataParams={...obj,...this.dataParams};
            ReactDOM.render(<WeaBrowser ecId={`_WeaBrowser@ep81qe`}
                type={type}
                title={column.title}
                hasAdvanceSerach={this.hasAdvanceSerach}
                scrollx = {this.scrollx}
                ref={(ref) => this.browserInstance = ref}
                onChange={changeValue}
                isSingle={isSingle}
                dataParams={this.dataParams}
                destDataParams={this.destDataParams}
                replaceDatas={replaceDatas}
                conditionDataParams={this.conditionDataParams}
                memorise={true}
                tabs={this.tabs}
            //    isMultCheckbox={true}
                // asynLoadAll ={column.asynLoadAll}
                defaultExpandedLevel={column.defaultExpandedLevel}
            />, this.editor);
            const openModal = () => {
                if (this.browserInstance) {
                    this.browserInstance.openModal();
                } else {
                    setTimeout(() => {
                        openModal();
                    }, 50);
                }
            }
            openModal();
        }
    }
    return Type;
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/stores/list/excel/celltypes/BrowserCellType.tsx